/* Request Customization — native <dialog> element
   - Uses showModal() which renders in the browser's top layer (above
     everything, regardless of z-index or stacking context).
   - Built-in ESC key handling and focus trap.
   - Scroll lock on body for iOS reliability.
   - Auto-opens on successful form submission (?posted=true).
*/
(function () {
  'use strict';

  var savedScrollY = 0;
  var lockedDialogs = 0;

  /* ---- iOS-safe body scroll lock --------------------------------------- */
  function lockBody() {
    if (lockedDialogs === 0) {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.style.top = '-' + savedScrollY + 'px';
      document.body.classList.add('cr-body-locked');
    }
    lockedDialogs++;
  }

  function unlockBody() {
    lockedDialogs = Math.max(0, lockedDialogs - 1);
    if (lockedDialogs === 0) {
      document.body.classList.remove('cr-body-locked');
      document.body.style.top = '';
      window.scrollTo(0, savedScrollY);
    }
  }

  /* ---- Dialog open / close --------------------------------------------- */
  function openDialog(dialog) {
    if (!dialog || dialog.open) return;

    if (typeof dialog.showModal === 'function') {
      try {
        dialog.showModal();
      } catch (err) {
        // Fallback: force attribute-based open
        dialog.setAttribute('open', '');
      }
    } else {
      // Very old browsers — fallback to visible attribute
      dialog.setAttribute('open', '');
    }

    lockBody();

    // Focus first visible input (native dialog already traps focus)
    window.setTimeout(function () {
      var firstInput = dialog.querySelector(
        'input:not([type="hidden"]):not([type="checkbox"]), textarea'
      );
      if (firstInput) firstInput.focus({ preventScroll: true });
    }, 80);
  }

  function closeDialog(dialog) {
    if (!dialog) return;

    if (typeof dialog.close === 'function' && dialog.open) {
      try {
        dialog.close();
      } catch (err) {
        dialog.removeAttribute('open');
      }
    } else {
      dialog.removeAttribute('open');
    }

    unlockBody();

    // Strip ?posted=true so refresh doesn't re-open the success state
    if (window.location.search.indexOf('posted=true') !== -1) {
      var url = new URL(window.location.href);
      url.searchParams.delete('posted');
      url.hash = '';
      window.history.replaceState({}, '', url.toString());
    }
  }

  /* ---- Event wiring ---------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cr-open]');
    if (opener) {
      e.preventDefault();
      var targetId = opener.getAttribute('data-cr-open');
      var dialog = targetId
        ? document.getElementById(targetId)
        : document.querySelector('[data-cr-modal]');
      openDialog(dialog);
      return;
    }

    var closer = e.target.closest('[data-cr-close]');
    if (closer) {
      e.preventDefault();
      var dialog = closer.closest('[data-cr-modal]');
      closeDialog(dialog);
      return;
    }

    // Click on the backdrop (the dialog element itself, not its child container)
    // closes the dialog. Native <dialog> makes the backdrop part of the element.
    if (e.target.matches && e.target.matches('dialog[data-cr-modal]')) {
      closeDialog(e.target);
    }
  });

  // Ensure scroll lock releases when dialog is closed via ESC (native behavior)
  document.addEventListener('close', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-cr-modal]')) {
      unlockBody();
    }
  }, true);

  /* ---- Init: auto-open on success ------------------------------------- */
  function init() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('posted') !== 'true') return;

    var dialogs = document.querySelectorAll('[data-cr-modal]');
    for (var i = 0; i < dialogs.length; i++) {
      if (dialogs[i].querySelector('[data-cr-success]')) {
        openDialog(dialogs[i]);
        break;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();